import api from './api'

export const fetchPrioritySummary = () =>
	api.get('/counseling/dashboard/priority-summary')
